module.exports = __webpack_public_path__ + "img/playButton.efe35d07.png";